// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Card, Image, Button } from 'semantic-ui-react'
import ScrollArea from '@xico2k/react-scroll-area'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ReactPlayer from 'react-player'
import GoogleMapReact from 'google-map-react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  CartesianGrid,
  ComposedChart,
  Legend,
  Area,
  Line
} from 'recharts'

export default class SingleRow extends Component {
  render () {
    var _this = this
    const details = this.props.components.map((item, index) => (
      <CopyToClipboard
        text={_this.props && _this.props.index && _this.props.index[item.value.source]}
        onCopy={() => {
          this.setState({
            copied: true
          })
          setTimeout(() => {
            this.setState({
              copied: false
            })
          }, 500)
        }}>
        <Card key={index} style={{ overflow: 'hidden', color: '#000' }}>
          <Card.Content>
            {item.value.type === 'text' && (
              <div style={{ color: '#000' }}>
                <h4>
                  <b>{item.value.label}</b>
                </h4>
                <p>{_this.props && _this.props.index && _this.props.index[item.value.source]}</p>
              </div>
            )}

            {item.value.type === 'url' && (
              <div>
                <Button
                  href={_this.props && _this.props.index && _this.props.index[item.value.source]}
                  rel='noopener noreferrer'
                  target='_blank'
                  color='black'
                  fluid
                  basic>
                  {item.value.label}
                </Button>
              </div>
            )}

            {item.value.type === 'email' && (
              <div>
                <h4>
                  <b>{item.value.label}</b>
                </h4>

                <a
                  href={
                    'mailto:' +
                    (_this.props && _this.props.index && _this.props.index[item.value.source])
                  }>
                  {_this.props && _this.props.index && _this.props.index[item.value.source]}
                </a>
              </div>
            )}
            {item.value.type === 'phone' && (
              <div>
                <h4>
                  <b>{item.value.label}</b>
                </h4>

                <a
                  href={
                    'tel:' +
                    (_this.props && _this.props.index && _this.props.index[item.value.source])
                  }>
                  {_this.props && _this.props.index && _this.props.index[item.value.source]}
                </a>
              </div>
            )}

            {item.value.type === 'address' && (
              <div style={{ height: '200px', width: '100%' }}>
                <GoogleMapReact
                  defaultCenter={{ lat: 59.95, lng: 30.33 }}
                  defaultZoom={10}
                  bootstrapURLKeys={{ key: 'AIzaSyBYCM8OCMwFVPhexSvnmV8BlCRdJkZde_Y' }}
                />
              </div>
            )}

            {item.value.type === 'image' && (
              <Image
                src={_this.props && _this.props.index && _this.props.index[item.value.source]}
                fluid
              />
            )}
            {item.value.type === 'video' && (
              <ReactPlayer
                url={_this.props && _this.props.index && _this.props.index[item.value.source]}
                width='100%'
                height='150px'
              />
            )}
            {item.value.type === 'audio' && (
              <ReactPlayer
                url={_this.props && _this.props.index && _this.props.index[item.value.source]}
                controls
                width='100%'
                height='50px'
              />
            )}
            {/* {item.value.type === 'chart' && (
              <BarChart
                barGap={1}
                width={400}
                height={220}
                // data={expenseChartData}
                margin={{
                  top: 5,
                  right: 0,
                  left: 0,
                  bottom: 0
                }}>
                <defs>
                  <linearGradient id='gradientEX' x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='5%' stopColor='#F55E64' stopOpacity={0.8} />
                    <stop offset='95%' stopColor='#F55E64' stopOpacity={0.5} />
                  </linearGradient>
                </defs>
                <XAxis dataKey='name' hide />
                <YAxis />
                <Tooltip />
                <ReferenceLine y={0} stroke='black' />
                <Bar dataKey='total' fill='url(#gradientEX)' stackId='a' />
                <Bar dataKey='transactions' fill='#F55E64' stackId='a' />
              </BarChart>
            )} */}
          </Card.Content>
        </Card>
      </CopyToClipboard>
    ))

    return (
      <ScrollArea trackHidden height='565px'>
        <div style={{ padding: 14 }}>{details}</div>
      </ScrollArea>
    )
  }
}
